import { styled } from '@mui/material';

export const H5Styled = styled('h6')(({ theme }) => ({
  paddingTop: theme.spacings.unit(7),
  color: theme.colors.primaryText,
  fontSize: theme.fonts.utility.size(9),
  fontWeight: 500,
  margin: 0,
}));
